module.exports = __webpack_public_path__ + "img/presenter_hippy@2x.011faddc.jpg";